import { IUserSession } from '../../../helpers/user-session'

import { LocalDictionaryFactory } from '../../api/api.module'
import { LoggerService } from '../../common/common.module'
import { ActionsDetailsDirectiveController } from './actions-details.directive.controller'
import { $Q_SERVICE_NAME, $SCOPE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'
import { USER_SESSION_SERVICE_NAME } from '../../../services/user-session'
import { ActionService, ACTION_SERVICE_NAME } from '../../../services/action'

//#region Asset Imports

import './actions-details.scss'
import * as TEMPLATE from './actions-details.tpl.html'

//#endregion

export class ActionsDetailsDirective implements ng.IDirective {
    restrict = 'E'
    scope = {
        id: '='
    }

    controller = [
        $SCOPE_SERVICE_NAME,
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'logger',
        'localDictionary',
        USER_SESSION_SERVICE_NAME,
        ACTION_SERVICE_NAME,
        (
            $scope,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            logger: LoggerService,
            localDictionary: LocalDictionaryFactory,
            userSession: IUserSession,
            actionService: ActionService,
        ) => {
            return new ActionsDetailsDirectiveController(
                $scope,
                $q,
                $timeout,
                logger,
                localDictionary,
                userSession,
                actionService,
                ActionService.REFERENCE_TYPE,
                ActionService.SIMAX_MODULE_NAME
            )
        }]
        
    template = TEMPLATE
}